import { Component } from 'react';
import ScrollToSiteContext from './ScrollToSiteContext';

export default class ScrollToSiteProvider extends Component {
  state = {
    isScrollToSite: false,
  };

  setIsScrollToSite = value => this.setState({ isScrollToSite: value });

  render() {
    return (
      <ScrollToSiteContext.Provider value={{
        isScrollToSite: this.state.isScrollToSite,
        setIsScrollToSite: this.setIsScrollToSite,
      }}
      >
        {this.props.children}
      </ScrollToSiteContext.Provider>
    );
  }
}
